import AudioLink from "./AudioLink";
import React from "react";
import ReactDOM from "react-dom";

class Collections extends React.Component {
    render(){
        console.log('collections: ',this.props);
        switch (this.props.layout) {
            // case 'third':
            //     return (
            //         <div className="audioLinks col-12">
            //             {this.props.items.map((item,index) => (
            //                 <AudioLink data={item}  key={"link_"+index}/>
            //             )) }
            //         </div>
            //         ); 
            //     break;
            default:
                return (
                    <div className="audioLinks col-12">
                        {this.props.items.map((item,index) => (
                            <AudioLink data={item}  key={"link_"+index}/>
                        )) }
                    </div>
                    ); 
                break;

        }
        
        }
}
export default Collections;
